import React from 'react';
import { Check } from 'lucide-react';
export function ResultsSection() {
  const studentBenefits = ['Comprenden la historia desde ejemplos reales', 'Conectan geografía con su vida cotidiana', 'Desarrollan pensamiento crítico', 'Participan más en clase', 'Entienden procesos sociales con claridad'];
  const teacherBenefits = ['Ahorrás horas de planificación', 'Enseñás con claridad y estructura', 'Tenés todo organizado por grado', 'Llegás sin estrés al cierre del año', 'Recuperás tiempo personal'];
  return <section className="bg-gray-50 py-16 px-4 md:px-8" data-id="element-149">
      <div className="max-w-5xl mx-auto" data-id="element-150">
        <h2 className="text-3xl md:text-5xl font-black text-center text-gray-900 mb-12" data-id="element-151">
          Resultados que Transforman
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-152">
          {/* Students */}
          <div className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-blue-500" data-id="element-153">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-154">
              Para tus Alumnos
            </h3>
            <ul className="space-y-4" data-id="element-155">
              {studentBenefits.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-156">
                  <Check className="w-6 h-6 text-blue-500 flex-shrink-0" data-id="element-157" />
                  <span className="text-lg text-gray-700" data-id="element-158">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Teachers */}
          <div className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-green-500" data-id="element-159">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-160">
              Para Vos como Maestra
            </h3>
            <ul className="space-y-4" data-id="element-161">
              {teacherBenefits.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-162">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-163" />
                  <span className="text-lg text-gray-700" data-id="element-164">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="text-center space-y-8" data-id="element-165">
          <a href="#compra" className="inline-block bg-green-600 hover:bg-green-700 text-white text-2xl font-bold py-5 px-10 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 animate-pulse" data-id="element-166">
            👉 QUIERO LOGRAR ESTO
          </a>

          <div className="pt-8" data-id="element-167">
            
          </div>
        </div>
      </div>
    </section>;
}